<template>
      <div :class="'col-custom-'+ css">
        <b-tooltip :label="currentEtichetta">
        {{this.currentEtichetta}}
        </b-tooltip>
      </div>
</template>

<script>
import Media from "../../../admin/media/media";
export default {
  name: "etichetta",
  components: {Media},
  props: ['etichetta', 'css'],
  data:function () {
    return {
      currentEtichetta: null,
    }
  },
  mounted() {
    this.getEtichetta()
  },
  methods: {
    getEtichetta :function () {
      let pathname = window.location.pathname.split('/');
      let cod_category = pathname[pathname.length - 2];
      let color = pathname[pathname.length - 1]

      axios({
        method: 'get',
        url: window.location.origin + '/data/get-family',
        params: {
          cod: this.etichetta,
          type: 'etichetta',
        }
      })
          .then(res => {

            this.currentEtichetta = res.data.family.descrizione


          })
          .catch(err => {


            this.$store.commit('add_message', {
              type: 'error',
              message: err.response.data.message
            })

          })
    }
  },
}
</script>

<style lang="scss" scoped>
//@media (max-width: 1500px) and (min-width: 1199px){
//  div {
//    max-width: 10ch;
//    overflow: hidden;
//    white-space: nowrap;
//    text-overflow: ellipsis;
//  }
// }
</style>
